import React, { Component } from 'react'
import { Mutation } from 'react-apollo'

import { SEND_PASSWORD_MAIL } from '../../mutations'

import Footer from '../../components/Footer/'
import ResetForm from '../../containers/ResetForm/'

import logo from '../../assets/logo.svg'
import desert from '../../assets/hero/login/desert.jpg'
import desertMobile from '../../assets/hero/login/desert-mobile.jpg'
import rock from '../../assets/hero/login/rock.jpg'
import rockMobile from '../../assets/hero/login/rock-mobile.jpg'
import sea from '../../assets/hero/login/sea.jpg'
import seaMobile from '../../assets/hero/login/sea-mobile.jpg'
import snow from '../../assets/hero/login/snow.jpg'
import snowMobile from '../../assets/hero/login/snow-mobile.jpg'
import { Container, Logo } from './styles'

class Forgotten extends Component {

  generateRandomImage() {
    let images = [
      {
        desktop: desert,
        mobile: desertMobile
      },
      {
        desktop: rock,
        mobile: rockMobile
      },
      {
        desktop: sea,
        mobile: seaMobile
      },
      {
        desktop: snow,
        mobile: snowMobile
      }
    ]

    // randomnize
    return images[Math.floor(Math.random() * images.length)]
  }


  render() {
    const hero = this.generateRandomImage()

    return (
      <Container image={hero.desktop} mobile={hero.mobile}>
        <Logo src={logo} alt="logo" />

        <Mutation mutation={SEND_PASSWORD_MAIL}>
          {(sendPasswordMail, { data, loading, error }) => {
            if (error) {
              return <ResetForm history={this.props.history} data={data} loading={loading} error={error.message.replace('GraphQL error:', '')} sendPasswordMail={sendPasswordMail} />
            }
            return <ResetForm history={this.props.history} data={data} error={''} loading={loading} sendPasswordMail={sendPasswordMail} />
          }}
        </Mutation>

        <Footer type="transparent" />
      </Container>
    )
  }
}

export default Forgotten



// WEBPACK FOOTER //
// ./src/views/Forgotten/index.js